import '../../site/plugins/kirby3-cookie-banner/dist/assets/cookie-banner-DSt9AXzp.js';

import ContactBar from "./components/contact-bar";

import BarbaJs from "./features/barba-js";
new BarbaJs();

document.documentElement.classList.replace('no-js', 'js');
